import { createRouter, createWebHistory } from 'vue-router';
import RenderPage from "@/views/painel/render/RenderPage.vue";

const routes = [

  { path: '/pages/:id',              name: 'render-pt', component: RenderPage },

  { path: '/en/pages/:id',           name: 'render-en', component: RenderPage, props: { lang: 'en' } },

  {
    path: '/search',
    name: 'SearchResults',
    component: () => import('@/views/sitegame/SearchResults.vue')
  },

  {
    path: '/newsletter-list',
    name: 'NewsletterList',
    component: () => import('@/views/painel/NewsletterList.vue'),
    meta: { requiresAuth: true } // se necessário
  },

  {
    path: '/contacts-list',
    name: 'ContactList',
    component: () => import('@/views/painel/ContactList.vue'),
    meta: { requiresAuth: true } // se necessário
  },

  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/sitegame/HomeView.vue')
  },
  { path: '/en/home',                name: 'home-en',   component: () => import('@/views/sitegame/HomeView.vue'), props: { lang: 'en' } },
  {
    path: '/notfound',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/painel/LoginView.vue')
  },
  {
    path: '/pages/:id',
    name: 'render',
    params: true,
    component: () => import('./views/painel/render/RenderPage.vue')
  },
  {
    path: '/painel',
    name: 'painel',
    component: () => import('@/views/painel/PainelView.vue')
  },
  {
    path: '/gamificacao/news',
    name: 'news',
    component: () => import('@/views/sitegamificacao/news/NewsPage.vue')
  },
  {
    path: '/projectcreate/:id',
    component: () => import('@/views/painel/ProjectsView.vue')
  },
  {
    path: '/gamecreate',
    component: () => import('@/views/painel/GamesView.vue')
  },
  {
    path: '/newcreate',
    component: () => import('@/views/painel/NewsView.vue')
  },
  {
    path: '/blogcreate',
    component: () => import('@/views/painel/PagesView.vue')
  },
  {
    path: '/politicadeprivacidade',
    component: () => import('@/views/sitegame/page-games/PolíticaPrivacidade.vue')
  },
  {
    path: '/home-edit',
    name: 'HomeEdit',
    component: () => import('@/views/painel/HomeEditView.vue')
  },
  {
    path: '/dashboard-analytics',
    name: 'DashboardAnalytics',
    component: () => import('@/views/painel/DashboardAnalytics.vue'),
  },
  {
    path: '/user-management',
    name: 'UserManagement',
    component: () => import('@/views/painel/UserManagement.vue'),
  },
  {
    path: '/deletarconta',
    component: () => import('@/views/sitegame/page-games/DeletarConta.vue')
  },
  {
    path: '/gamificacao/home',
    name: 'gamificacao-home',
    component: () => import('@/views/sitegamificacao/home/HomeView.vue')
  },
  {
    path: '/gamificacao/contact',
    name: 'gamificacao-contact',
    component: () => import('@/views/sitegamificacao/ContactView.vue')
  },
  {
    path: '/gamificacao/projects',
    name: 'gamificacao-projects',
    component: () => import('./views/sitegamificacao/ProjectsPage.vue')
  },
  {
    path: '/',
    redirect: '/home'
  },
  //{
    //path: '/:pathMatch(.*)*',
    //redirect: '/notfound'
  //},
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

export default router;
